import { Component, inject, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  CrudbarNavComponent,
  JackBaseComponentModule,
  jkGlb,
  MaterialModule,
  minioAttachPath,
  PageKind,
  UiModeType,
} from 'jk-service';
import { AdvComModule, jkSingleComponent } from 'jk-advcom';
import { MtrwbService, templateUrlConfigMtr } from '../_service_mtr';
import { MtrwbEditComponent } from '../_edit_mtr';
import {
  jkLib,
  kmAttach,
  UploadFileComponent,
  entityState,
  JkTableService,
} from 'jk-service';
import { Mtrwb } from '../_entity_mtr';

@Component({
  selector: 'app-mtrki02',
  standalone: true,
  providers: [],
  imports: [MaterialModule, JackBaseComponentModule, AdvComModule],
  templateUrl: './mtrki02Pkg.component.html', // ###
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Mtrki02PkgComponent extends jkSingleComponent implements OnInit {
  override _programId = 'mtrki02';
  constructor() {
    super();
    this.srv = new MtrwbService();
    this.uiMode = UiModeType.dialog;
    this.title = '問題反應單建立';
    this.gridInitOpt = {
      programId: this.programId,
      sortField: 'WB004',
      sort: 'desc',
      defaultSort: null,
      pageKind: this.pageKind,
    };
    this.masterEditPage = MtrwbEditComponent;
    //this.constructorInit();
  }
  override onWindowResize($event?: any) {
    super.onWindowResize($event);
  }

/*   override async constructorInit() {
    await super.constructorInit();
    if (this.srv.isAdmin) {
      this.qbeConfig.addField =
        'WB004,WB024,WB003,WB005,WB012,WB013,WB014,WB028'; // ### jackie
      this.qbeConfig.addWhere = ''; // ### jackie
    } else {
      this.qbeConfig.addField = 'WB004,WB005,WB012,WB013,WB014,WB028'; // ### jackie
      this.qbeConfig.addWhere = ''; // ### jackie
    }
    this.srv.setOrder('1');
    this.doRefresh();
  }

  getImagePath(item: Mtrwb): string {
    return `${item.WB001}-${item.WB002}` || 'unknown';
  }

  doUploadMinio() {
    const item = this.item; // this.masterGrid.selectedItem;
    if (!jkLib.haveValue(item)) {
      alert('請先選單號!!!');
      return;
    }
    if (item.WB001 === '' || item.WB002 === '') {
      alert('請先選單號!!!');
    } else {
      const uploadHost = this.login.host;
      minioAttachPath(
        this.dialog,
        uploadHost,
        this.getImagePath(item),
      ).subscribe((result) => {
        if (result) {
          const files = result.rowsAffected;
          if (files) {
            if (typeof files === 'number') {
              // item.WB035 = item.WB035 + files; TODO:
            }
          }
        } //if
      });
    }
  }

  doUpload(item: Mtrwb) {
    if (!jkLib.haveValue(item)) {
      alert('請先選單號!!!');
      return;
    }
    if (item.WB001 === '' || item.WB002 === '') {
      alert('請先選單號!!!');
    } else {
      //var urlUpload = "http://www.jack168.com/upload/default.aspx"; // ?path=//nas5/Public/附件區/" + jkGlb.User.dbname() + "/YYYYMM/工作日報/W102-" + TD002;
      // DBNAME/工作日報/年月/單別-單號
      // urlUpload = urlUpload + "?path=C:/rd/附件區/" + jkGlb.User.dbname + "/" + myTable.getField("CREATE_DATE").substring(0, 6) + "/" + myTable.billType() + "-" + myTable.billNo();
      //urlUpload = urlUpload + "?path=D:/附件區/" + this.login.dbname + "/" + this.item.CREATE_DATE.substring(0, 6) + "/" + this.entityType.billType + "-" + this.entityType.billNo;
      // JkuploadComponent TODO: 測試
      let uploadHost = jkGlb.env.baseAttachUrl; //"http://rmserver.jack168.com/emonapp/upload/default.aspx";
      if (!uploadHost) {
        uploadHost = this.login.host;
      }
      let basePath = '/mnt/附件區';
      // \\jkw10-vm\data\附件區 --> /mnt/附件區
      //let uploadDirectory = `${basePath}/${this.login.dbname}/${date.substring(0, 6)}/${this.srv.entityType.billType}-${this.srv.entityType.billNo}`;
      kmAttach(
        this.dialog,
        this.login.dbname,
        uploadHost,
        basePath,
        item.CREATE_DATE,
        this.srv.entityType.billType,
        item.WB002,
      ).subscribe((result) => {
        if (result) {
          const files = result.rowsAffected;
          if (files) {
            if (typeof files === 'number') {
              // item.WB035 = item.WB035 + files; TODO:
            }
          }
        } //if
      });
    }
  }
 */}
